var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-end"},[_c('div',[_vm._v(" "+_vm._s(_vm.paginateStart)+" - "+_vm._s(_vm.paginateStart + _vm.items.length - 1)+" of "+_vm._s(_vm.totalItems)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }